<template>
    <div
        class="Badge"
        :class="[
            `is-${colorId}`,
            { 'is-small': size === 'small' },
            { 'is-large': size === 'large' },
        ]"
        :style="badgeStyle"
    >
        <div class="Badge-Wrapper">
            <span v-if="hasIcon" class="IconBefore">
                <slot name="iconBefore"></slot>
            </span>
            <span class="Label">
                <span v-if="value">{{ value }}</span>
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script>
import { getColorById } from '@/utils/calendarColors.js';

export default {
    name: 'Badge',
    props: {
        colorId: {
            type: String,
            default: 'color-1',
        },
        size: {
            type: String,
            default: 'medium',
        },
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasIcon() {
            return !!this.$slots.iconBefore;
        },
        badgeStyle() {
            const color = getColorById(this.colorId);
            if (!color) return {};

            return {
                backgroundColor: color.background,
                color: color.text,
                borderColor: `color-mix(in srgb, ${color.border} 40%, transparent)`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.Badge {
    display: inline-flex;
    align-items: center;
    border: 0.5px solid;
    border-radius: 20px;
    padding: 6px 12px;
    font-size: 0.75rem;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.2s ease;
    user-select: none;

    &.is-small {
        padding: 4px 8px;
        font-size: 0.65rem;
    }

    &.is-large {
        padding: 8px 16px;
        font-size: 0.85rem;
    }

    .Badge-Wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .IconBefore {
        display: flex;
        align-items: center;
        font-size: 1em;
    }

    .Label {
        display: flex;
        align-items: center;
        line-height: 1;
        opacity: 0.75;

        span {
            white-space: nowrap;
        }
    }
}
</style>
